<template>
  <div v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-dialog
      @opened="opened"
      title="Modify Role"
      :visible.sync="editRoleDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="500px"
      size="small">

      <el-form
        label-position="left"
        label-width="140px"
      >
        <el-form-item label="Role View Name: "  required>
          <el-input v-model="roleDTO.role_view_name" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Role Key: "  required>
          <el-input v-model="roleDTO.role_name" size="small" disabled></el-input>
        </el-form-item>
        <el-form-item label="Description: ">
          <el-input v-model="roleDTO.description" size="small" ></el-input>
        </el-form-item>
        

      </el-form>

      <span slot="footer" class="dialog-footer">
              <el-button type="success" @click="saveRole">Save</el-button>
              <el-button @click="editRoleDialogVisible = false">close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import util from '@/util/util.js'

  export default {
    components: {
    },
    props:{
      roleInfo: {
        type: Object,
        required: true,
        default:() => {}
      }
    },
    data(){
      return{
        editRoleDialogVisible: false,
        roleDTO:{
        },
        dataLoading: false,

      }
    },
    watch:{

    },
    computed: {
    },
    created(){
    },


    methods: {
      opened(){
        this.roleDTO = util.deepClone(this.roleInfo);
      },
      showEditRoleDialog(){

        this.editRoleDialogVisible = true;
      },
      hideEditRoleDialog(){
        this.editRoleDialogVisible = false;
      },
      saveRole(){
        let url = this.baseAcsUrl + '/acs/role/update-role';
        if(!this.roleDTO.role_name){
          this.$message.warning("Role Key can't be empty");
          return;
        }
        if(!this.roleDTO.role_view_name){
          this.$message.warning("Role View Name can't be empty");
          return;
        }

        this.dataLoading = true;
        this.roleDTO.appKey = this.roleDTO.app_key;
        this.roleDTO.roleName = this.roleDTO.role_name;
        this.roleDTO.roleViewName = this.roleDTO.role_view_name;

        this.http.put(url,this.roleDTO).then(resp =>{
          this.$message.success('Successful operation ');
          this.editRoleDialogVisible = false;
          this.dataLoading = false;
          this.$emit("saveSuccess");
        } ).catch(error => {
          this.dataLoading = false;
          console.info(error);
          this.$emit("saveFail");

        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
 .el-form-item /deep/ .el-select{
   display: inline-block;
   width: 86%;
  }
  .add-banner-group  /deep/ .el-form-item__label{
    width: 148px !important;
  }
  .add-banner-group /deep/ .el-form-item__content{
    margin-left: 148px!important;
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/role/dialog/edit_role.vue